import React, { useState } from "react";
import {
  PrimaryButton,
  StyledInput,
} from "../../components/common/common.style";
import { Container, FormStyled, LoginBox, Title } from "./loginPage.styled";
import { Box } from "../../components/primitives";
import { useLoginMutation } from "../../services/myServer/auth";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { setJwtToken } from "../../store/slices/global";

export const LoginPage = () => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [login, { isLoading, error }] = useLoginMutation();
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const handleLogin = async (e: React.FormEvent) => {
    e.preventDefault();
    try {
      const result = await login({ email, password }).unwrap();
      localStorage.setItem("authToken", result.token);
      dispatch(setJwtToken(result.token));
      navigate("/upload-cards");
    } catch (err) {
      console.error("Failed to login", err);
    }
  };

  return (
    <Container>
      <LoginBox>
        <Title>Login</Title>
        <FormStyled onSubmit={handleLogin}>
          <StyledInput
            type="email"
            placeholder="Email"
            required
            value={email}
            onChange={(e) => setEmail(e.target.value)}
          />
          <StyledInput
            type="password"
            placeholder="Password"
            required
            value={password}
            onChange={(e) => setPassword(e.target.value)}
          />
          {/* <Box css={{ textAlign: "center", marginBottom: "1rem" }}>
            <strong>Account creation is currently disabled.</strong> <br />
            Please use this test account for now.
          </Box>
          <Box>edoardo.test@gmail.com</Box>
          <Box>password123</Box> */}
          {error && (
            <Box css={{ color: "red", marginTop: "1rem" }}>
              Login failed. Please check your credentials.
            </Box>
          )}
          <PrimaryButton type="submit" disabled={isLoading} isBig>
            {isLoading ? "Logging in..." : "Log In"}
          </PrimaryButton>
        </FormStyled>
      </LoginBox>
    </Container>
  );
};
